import { Head, Link } from '@inertiajs/react';
import type { ArcadeGamesIndex } from '@/types';
import { CityTabs } from './components/city-tabs';
import { GamesGrid } from './components/games-grid';
import { Leaderboard } from './components/leaderboard';
import { SubmitGameButton } from './components/submit-game-button';

export default function Index({
  games,
  instances,
  activeSlug,
  submissionOpen,
  submissionDeadline,
  votingOpen,
  timezone,
  submitHref,
  authenticated,
  hasGoogleAccount,
}: ArcadeGamesIndex) {
  return (
    <>
      <Head title="Arcade Games | Platanus Hack 26">
        <meta
          name="description"
          content="Browse and play all arcade games from Platanus Hack 26"
        />
      </Head>
      {/* app/(public)/26/arcade/layout.tsx wraps this whole tree in a black page. */}
      <div className="min-h-screen bg-black">
      <div className="theme-ph26 min-h-screen bg-background font-sans text-foreground">
        <div className="container mx-auto px-4 py-12 md:py-16">
          <div className="relative mb-12 flex flex-col gap-6 text-center">
            <div className="z-10 flex justify-center md:absolute md:top-0 md:right-0 md:justify-end">
              <SubmitGameButton
                open={submissionOpen}
                deadlineIso={submissionDeadline}
                timezone={timezone}
                href={submitHref ?? undefined}
              />
            </div>
            <Link
              href="/"
              className="relative inline-block transition-opacity hover:opacity-80"
            >
              <h1 className="font-bold font-logo text-4xl lowercase tracking-tighter md:text-5xl lg:text-6xl">
                <span className="font-light text-primary">platanus hack</span>{' '}
                <span className="font-medium text-primary">[26]</span>
              </h1>
            </Link>
            <h2 className="font-bold font-sans text-3xl text-primary md:text-4xl lg:text-5xl">
              <span className="inline-flex flex-col items-center bg-primary px-3 py-1 text-background">
                arcade games
              </span>
            </h2>
            <CityTabs instances={instances} activeSlug={activeSlug} />
          </div>

          <Leaderboard games={games} activeSlug={activeSlug} />

          <GamesGrid
            games={games}
            isAuthenticated={authenticated}
            hasGoogleAccount={hasGoogleAccount}
            votingOpen={votingOpen}
          />
        </div>
      </div>
      </div>
    </>
  );
}
